






























import { Component, Prop, Vue } from 'vue-property-decorator';
import TodoListTable from './todoListTable.vue';
import { releaseTodoListInstance } from '@/model/ReleaseTodoListClass';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;

@Component({
  name: 'ReleaseTodoList',
  components: {
    TodoListTable,
  },
})
export default class ReleaseTodoList extends Vue {
  @Prop({ default: false }) private spinning!: boolean;
  @Prop({ required: true, default: () => [] }) private todos!: IGrabTodoInfo[];
  @Prop({ default: ''}) private activeKey!: string;
  private currentTodo: IGrabTodoInfo | null = null;
  private visible = false;
  private comment = '';
  private confirmLoading = false;
  private goModulePage(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
  private handleAgreeOwner(todo: IGrabTodoInfo) {
    releaseTodoListInstance.requestAgreeOwner(todo).then((res) => {
      this.$message.success('Success');
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleRefuseOwner() {
    if (!this.currentTodo) {
      return;
    }
    releaseTodoListInstance.requestRefuseOwner({
      todoId: this.currentTodo.id,
      comment: this.comment,
    }).then((res) => {
      this.$message.success('Success');
      this.currentTodo!.ownerName = '';
      this.currentTodo!.owner = null;
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.visible = false;
    });
  }
  private handleDeleteTodo(todo: IGrabTodoInfo) {
    releaseTodoListInstance.requestUndoTodo(todo.id).then((res) => {
      this.$message.success('Success');
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleShowModal(todo: IGrabTodoInfo) {
    this.currentTodo = todo;
    this.visible = true;
    this.comment = '';
  }
  private handleCancel() {
    this.visible = false;
  }
}
